<template>
  <div class="logContainer">
    <Tabs type="card" v-model="type" class="tabsCon pr f12" ref="tabsCon">
      <TabPane class="tabpaneCon " :name="item.type" :label="item.label" @click="type = item.type"
        v-for="(item, index) in navList" :key="index + '-' + item.type">
        <proCom :type="type" :id="id" v-if="type == item.type" :splitVal="splitVal" :columnsData="columns"
          :search="item.search" :placeHolder="item.placeHolder" :titles="item.label" />
      </TabPane>
    </Tabs>
  </div>
</template>
<script>
import proCom from './log/pro.vue'
import { getLogSearch, getLogTitle } from '../../../requests/debug'
export default {
  props: ['splitVal', 'id', 'debug'],
  components: {
    proCom,
  },
  data () {
    return {
      type: 1,
      navList: [],
      total: 50,
      size: 50,
      page: 1,
      splitVals: '',
      columns: []
    }
  },
  watch: {
    splitVal () {
      this.splitVals = this.splitVal
    }
  },
  mounted () {
    this.splitVals = this.splitVal
    if (this.debug) {
      this.type = '1'
      this.getLogSearch()
    } else {
      let json = {
        type: '100000',
        label: '开机通道日志'
      }
      this.type = '100000'
      this.navList.push(json)
    }
  },
  methods: {
    async getLogTitle () {
      let wid = this.$refs.tabsCon.clientWidth
      let res = await getLogTitle({
        type: this.type
      })
      if (res.code == 200) {
        res.data.forEach((element, index) => {
          let json = ''
          json = {
            title: element.label,
            key: element.attr,
            minWidth: 70
          }
          this.columns.push(json)
        })
      }
    },
    async getLogSearch () {
      let res = await getLogSearch()
      if (res.code == 200) {
        let json = {
          type: '100000',
          label: '开机通道日志'
        }
        res.data.push(json)
        this.navList = res.data
        this.type = res.data[0].type
        // this.getLogTitle()
      }
    },
    // select (val) {
    //   this.type = val
    // }

  },
}
</script>
<style lang="scss" scoped>
.tabsCon,
.logContainer {
  height: 100%;
}

// .tabsCon {
//   height: 100%;

//   // .ivu-tabs-content {
//   //   height: calc(100% - 45px) !important;
//   // }
// }
.pageCon {
  right: 0;
  bottom: 0px;
}
</style>
<style lang="scss">
.tabsCon {
  .ivu-tabs-content {
    height: calc(100% - 48px);
  }
}

.ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab {
  font-size: 12px;
}

.ivu-select-single .ivu-select-selection .ivu-select-placeholder,
.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
  font-size: 12px;
}
</style>